import React, { useState } from 'react'
import { useAuthContext } from '../../../hooks/useAuthContext';
import axios from 'axios';
import { ApiConnectionString } from '../../../constants/ApiConntection';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default function RenewSubModal({cancelModal, fetchData, id }) {
      const [complete, setComplete] = useState(false);
      const [isLoading, setIsLoading] = useState(false);
      const {user} = useAuthContext();

        const renewSub = async () => {
          try {
            setIsLoading(true);
        
            const renewSubResponse = await axios.put(`${ApiConnectionString}/api/subscription/${id}`,null, {
              headers: { Authorization: `Bearer ${user.token}` },
            });
        
            if (renewSubResponse.status === 200) {
              setComplete(true);
            }
          } catch (error) {
            console.error("Failed to renew subscription:", error);
          } finally {
            setIsLoading(false);
          }
        };

      if (isLoading) {
        return (
          <div>
            <div className="send-modal-overlay">
              <div className="send-modal">
              <LoadingSpinner />
              </div>
             
            </div>
          </div>
        );
      } else if (complete) {
        return (
          <div className="send-modal-overlay">
            <div className="send-modal">
              <div className="blueBanner">
                <p className="fw-bold m-2 p-2 fontSize20">Subscription Renewed</p>
              </div>
              <p>
                Your subscription has been successfully Renewed.
              </p>
    
              <div className="send-modal-footer">
                <button className="pointer cancelButton fw-bold mx-2 px-3" onClick={fetchData}>Close</button>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="send-modal-overlay">
            <div className="send-modal">
              <div className="blueBanner">
                <p className="fw-bold m-2 p-2 fontSize20">Renew Subscription</p>
              </div>
              <p>Are you sure that you want to renew this subscription?</p>
    
              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>
    
              <div className="send-modal-footer">
                <button className="saveChanges-button" onClick={renewSub}>
                  Renew this subscription
                </button>
                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        );
      }
    }
    